var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushAuthIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0074BD",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 28c.952 0 1.754-.337 2.406-1.012.652-.674.979-1.504.979-2.488v-21c0-.984-.327-1.814-.979-2.488C23.754.337 22.952 0 22 0H10.154C9.202 0 8.4.337 7.748 1.012c-.653.674-.979 1.504-.979 2.488v21c0 .984.326 1.814.979 2.488C8.4 27.663 9.202 28 10.154 28H22zm.05-2.545H10.103a.817.817 0 01-.613-.248.873.873 0 01-.24-.634V3.427c0-.257.08-.469.24-.634a.817.817 0 01.613-.248H22.05c.25 0 .454.083.614.248.16.165.24.377.24.634v21.146c0 .257-.08.469-.24.634a.817.817 0 01-.614.248zm-4.318-1.91c.24 0 .44-.089.594-.268.155-.179.233-.408.233-.686 0-.279-.078-.507-.233-.686a.752.752 0 00-.594-.269h-3.31c-.241 0-.44.09-.594.269-.156.179-.233.407-.233.686 0 .278.077.507.233.686a.752.752 0 00.594.268h3.31z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.077 5.94h2.369v15.272h-2.37zM30.63 9.024H33v9.256h-2.37z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.923 21.212H3.554V5.94h2.37zM2.37 18.127H0V8.871h2.37z"
  })))));
}
export default SvgPushAuthIco;